<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  enabled: { type: Boolean, default: false },
})

defineEmits(['show-position-overlay'])

const theme = useTheme()
</script>

<template>
  <v-chip
    class="px-4"
    prepend-icon="mdi-crosshairs-gps"
    :append-icon="props.enabled ? 'mdi-check-circle' : undefined"
    variant="elevated"
    :color="props.enabled ? 'primary' : theme.current.value.colors.surface"
    @click="$emit('show-position-overlay')"
  >
    {{ $t('canvas.settings.overlay.position.title') }}
  </v-chip>
</template>
